var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 3,
      strokeMiterlimit: 10,
      stroke: "#555",
      fill: "none",
      strokeLinejoin: "round",
      strokeLinecap: "round"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m55.737 16.309 3.674-3.67a5.675 5.675 0 1 0-8.025-8.025l-3.674 3.669M17.337 54.667l38.4-38.358-8.025-8.026L9.307 46.642 2.926 61.049zm-8.03-8.025 8.03 8.025"
  }))));
};
export default SvgPencil;